import {
  STOCK_TAKING_CAR_MANAGEMENT_CLEAR_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_CLEAR_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAILURE
} from '../constants'

export function clearCurrentTakingCar() {
  return (dispatch, getState) => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_CLEAR_BEGIN
    })

    try {

      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_CLEAR_SUCCESS,
      })

    } catch (err) {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_CLEAR_FAILURE,
        data: err?.message
      })
    }
  }
}
